/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/prefer-single-boolean-return */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-console */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-nested-template-literals */
/* eslint-disable */
import React, { useState, useContext } from 'react';
import {
    Card,
    Grid,
    CardContent,
    ListItem,
    List,
    Box,
    RACSelect,
    Typography,
} from '@rentacenter/racstrap';
import { customerStyles } from './customerStyles';
import { DapCalendarStyles } from './DapCalendarStyles';
import { FeatureFlagContext } from '../../../context/featureFlagContext';
import { useTranslation } from 'react-i18next';
enum tabList {
    CALENDAR,
    GOALS
}
function Tab(props: any) {

    const customerStyleClasses = customerStyles();
    const classes = DapCalendarStyles();
    const { taskandGoals, MXStoreIdentifier } = useContext(FeatureFlagContext)
    const [activetab, setactivetab] = useState(
        {
            calender: true,
            tasks: false,
            goals: false
        }

    );

    const { setTab, storeEventDD, assigneeEventDD, assignee, setassignee, store, setStore } = props;
    const { t, i18n } = useTranslation('dashboard')


    return (
        <Grid container>
            <Card
                className={`${classes.cardForDashboard} ${customerStyleClasses.w100} ${customerStyleClasses.borderRadiusZero}`}
            >
                {/* <Card className={`${classes.w100} ${classes.card1}`}> */}

                <CardContent
                    className={`${classes.headerTab} ${customerStyleClasses.floatLeft} ${customerStyleClasses.w100} ${classes.py0}`}
                >
                    <Grid

                        className={`${customerStyleClasses.floatLeft} ${classes.customGridWidth} `}
                    >
                        <Box className={`${customerStyleClasses.floatLeft}`} /* ${customerStyleClasses.w100} */ >
                            <List
                                className={`${classes.racpadTab} ${classes.py0} ` /* ${customerStyleClasses.w100} */}
                                id="CustTab"
                                role="tabList"
                                style={{ justifyContent: 'space-between' }}
                            >
                                <ListItem
                                    className={
                                        activetab.calender
                                            ? `${classes.navLinkActive} ${classes.navLinkItem}`
                                            : `${classes.navLinkItem} ${classes.p3}`
                                    }
                                    style={{ color: 'black' }}
                                    id="Customerinfo-tab"
                                    data-testid="customerInfoTab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#customerinfo"
                                    role="tab"
                                    aria-controls="Customerinfo-tab"
                                    aria-selected="true"
                                    onClick={() => { setactivetab({ ...activetab, calender: true, tasks: false, goals: false }); setTab('calender') }}                                 >
                                    {t('Upcoming Events')}
                                </ListItem>
                                {taskandGoals == '1' ?
                                    <ListItem
                                        className={
                                            activetab.tasks
                                                ? `${classes.navLinkActive} ${classes.navLinkItem}`
                                                : `${classes.navLinkItem} ${classes.p3}`
                                        }
                                        style={{ color: 'black', width: 'fit-content' }}
                                        id="Customerinfo-tab"
                                        data-testid="customerInfoTab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#customerinfo"
                                        role="tab"
                                        aria-controls="Customerinfo-tab"
                                        aria-selected="true"
                                        onClick={() => { setactivetab({ ...activetab, calender: false, tasks: true, goals: false }); setTab('Task') }}                                    >
                                        {t('Upcoming Tasks')}
                                    </ListItem> : null}
                                <Box>
                                    <List
                                        id="CustTab"
                                        role="tabList"
                                        style={{ justifyContent: 'space-between' }}
                                    >
                                    </List>
                                </Box>
                            </List>
                        </Box>
                        {(Number(MXStoreIdentifier) == 1) ? (
                            <>
                                <ListItem
                                    className={`${customerStyleClasses.w100} ${classes.listSyle} ${classes.p0} ${classes.listTag}`}
                                // style={{ display: 'flex', justifyContent: 'flex-end' }}

                                >
                                    <Grid className={` /* ${classes.listSyle} */ ${classes.dropdownWidth}`}>
                                        <Typography>{t("Store")}</Typography>
                                        <RACSelect
                                            name="store"
                                            classes={{ formControl: classes.p3 }}
                                            options={storeEventDD}
                                            onChange={(e: any) => {
                                                setStore(e.target.value)
                                            }
                                            }
                                            defaultValue={
                                                store !== undefined &&
                                                    store !== null &&
                                                    store !== ''
                                                    ? String(store)
                                                    : ''
                                            }
                                        />
                                    </Grid>
                                    <Grid className={` ${classes.listSyle}  ${classes.dropdownWidth}`}>
                                        <Typography>{t("Assignee")}</Typography>
                                        <RACSelect
                                            name="assignee"
                                            classes={{ formControl: classes.p3 }}
                                            options={assigneeEventDD}
                                            onChange={(e: any) => {
                                                setassignee(e.target.value)
                                            }
                                            }
                                            defaultValue={
                                                assignee !== undefined &&
                                                    assignee !== null &&
                                                    assignee !== ''
                                                    ? String(assignee)
                                                    : ''
                                            }
                                        />
                                    </Grid>
                                </ListItem>
                            </>) : (<></>)}
                    </Grid>
                </CardContent>

            </Card>
        </Grid>)
}

export default Tab;